module.exports = __webpack_public_path__ + "img/candy.be5030ca.webp";